export function validEmail(value) {
  if (/^[^@]+@\w+(\.\w+)+\w$/.test(value)) {
    return true;
  } else {
    return false;
  }
}
